import {useApplication} from './ApplicationProvider';
import {createBrowserRouter, Navigate, RouterProvider} from 'react-router-dom';
import * as React from 'react';
import {observer} from 'mobx-react';
import AppLayoutScreen from "././functionalities/app_layout/AppLayoutScreen";
import HomeScreen from "./functionalities/home/SupportScreen";
import ListOrdersScreen from "./functionalities/orders/list_orders/ListOrdersScreen";
import {
    ALLOWANCES_PATH,
    ASSIGN_PERMISSIONS_PATH,
    ASSIGN_ROLES_USER_PATH,
    AUTHORIZATION_PATH,
    AUTHORIZATIONS_PATH,
    BACKOFFICE_USERS_PATH,
    BUDGET_PATH,
    CREATE_ALLOWANCE_PATH,
    CREATE_LEAD_PATH,
    LEAD_ASSIGNMENT_QUEUE_PATH,
    CREATE_BACKOFFICE_USER_PATH,
    CREATE_CUSTOMER_ONBOARDING_PATH,
    CREATE_ORDER_PATH,
    CREATE_USER_PATH,
    CURRENT_ACCOUNTS_PATH,
    CUSTOMER_ONBOARDING_EDITION_PATH,
    CUSTOMER_ONBOARDINGS_PATH,
    CUSTOMER_PATH,
    CUSTOMERS_PATH,
    DASHBOARD_PATH,
    DELIVERY_SITE_ONBOARDING_CREATE_PATH,
    DELIVERY_SITE_ONBOARDING_EDIT_PATH,
    DELIVERY_SITE_PATH,
    LOGIN_PATH,
    MARKETPLACE_DEMO_PATH,
    ORDER_LOG_PATH,
    ORDER_PATH,
    ORDERS_PATH,
    PASSWORD_RESET_PATH,
    PURCHASE_ORDERS_PATH,
    SUPPORT_PATH,
    SOLD_BOXES_BY_CUSTOMER_AND_ARTICLE_PATH,
    USERS_PATH,
    VIEW_AUTHORIZATION_PATH,
    VIEW_CURRENT_ACCOUNT_PATH,
    VIEW_ORDER_PATH
} from "./routes";
import LoginScreen from "./functionalities/login/LoginScreen";
import CreateOrderScreen from "./functionalities/orders/create_order/CreateOrderScreen";
import OrderScreen from "./functionalities/orders/OrderScreen";
import ListPurchaseOrderScreen from "./functionalities/purchase_order/ListPurchaseOrderScreen";
import ListCurrentAccountsScreen
    from "./functionalities/current_accounts/list_current_accounts/ListCurrentAccountsScreen";
import CurrentAccountScreen from "./functionalities/current_accounts/CurrentAccountScreen";
import ListMarketplaceUsersScreen from "./functionalities/users/list_marketplace_users/ListMarketplaceUsersScreen";
import CreateUserScreen from "./functionalities/users/create_user/CreateUserScreen";
import AssignRolesScreen from "./functionalities/users/assign_roles/AssignRolesScreen";
import OrderLogScreen from "./functionalities/orders/OrderLogScreen";
import ListAuthorizationsScreen from "./functionalities/authorizations/ListAuthorizationsScreen";
import AuthorizationScreen from "./functionalities/authorizations/AuthorizationScreen";
import RecoverPasswordScreen from "./functionalities/recover_password/RecoverPasswordScreen";
import ListBackofficeUsersScreen from "./functionalities/users/list_backoffice_users/ListBackofficeUsersScreen";
import CreateUserFeature from "./functionalities/users/create_user/CreateUserFeature";
import CreateBackofficeUserFeature from "./functionalities/users/create_user/CreateBackofficeUserFeature";
import AssignPermissionsScreen from "./functionalities/users/permissions/AssignPermissionsScreen";
import ListCustomerOnboardingScreen from "./functionalities/customer_onboarding/ListCustomerOnboardingScreen";
import CreateCustomerOnboardingScreen from "./functionalities/customer_onboarding/CreateCustomerOnboardingScreen";
import CustomerOnboardingEditionScreen
    from "./functionalities/customer_onboarding/edition/CustomerOnboardingEditionScreen";
import DashboardScreen from "./functionalities/dashboard/DashboardScreen";
import CreateAllowanceScreen from "./functionalities/allowances/create_allowance/CreateAllowanceScreen";
import ListAllowancesScreen from "./functionalities/allowances/list_allowances/ListAllowancesScreen";
import CreateLeadScreen from "./functionalities/crm/create_lead/CreateLeadScreen";
import LeadAssignmentQueueScreen from "./functionalities/crm/lead_assignment_queue/LeadAssignmentQueueScreen";
import ListCustomersScreen from "./functionalities/customers/ListCustomersScreen";
import CustomerScreen from "./functionalities/customers/CustomerScreen";
import DeliverySiteOnboardingCreateScreen
    from "./functionalities/delivery_site_onboarding/DeliverySiteOnboardingCreateScreen";
import DeliverySiteOnboardingEditScreen from "./functionalities/delivery_site_onboarding/DeliverySiteOnboardingScreen";
import DeliverySiteScreen from "./functionalities/delivery_sites/DeliverySiteScreen";
import BudgetScreen from "./functionalities/budget/BudgetScreen";
import SoldBoxesByCustomerAndArticleScreen from "./functionalities/operations/sold_boxes_by_customer_and_article/SoldBoxesByCustomerAndArticleScreen";
import MarketplaceDemoScreen from "./functionalities/demo_tienda/MarketplaceDemoScreen";

export default observer(AppRouter);


function AppRouter() {
    const application = useApplication();
    const authenticatedRoutes = [
        {
            path: SUPPORT_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <HomeScreen/>
                },
            ]
        },
        {
            path: DASHBOARD_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <DashboardScreen/>,
                },
            ]
        },
        {
            path: BUDGET_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <BudgetScreen/>,
                },
            ]
        },
        {
            path: CREATE_LEAD_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <CreateLeadScreen/>,
                },
            ]
        },
        {
            path: LEAD_ASSIGNMENT_QUEUE_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <LeadAssignmentQueueScreen/>,
                },
            ]
        },
        {
            path: SOLD_BOXES_BY_CUSTOMER_AND_ARTICLE_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <SoldBoxesByCustomerAndArticleScreen/>,
                },
            ]
        },
        {
            path: PURCHASE_ORDERS_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <ListPurchaseOrderScreen/>,
                },
            ]
        },
        {
            path: ORDERS_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <ListOrdersScreen/>,
                },
            ]
        },
        {
            path: CREATE_ORDER_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <CreateOrderScreen/>,
                },
            ]
        },
        {
            path: ALLOWANCES_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <ListAllowancesScreen/>,
                },
            ]
        },
        {
            path: CREATE_ALLOWANCE_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <CreateAllowanceScreen/>,
                },
            ]
        },
        {
            path: ORDER_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    path: VIEW_ORDER_PATH,
                    element: <OrderScreen/>,
                },
            ]
        },
        {
            path: ORDER_LOG_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <OrderLogScreen/>,
                },
            ]
        },
        {
            path: CUSTOMER_ONBOARDINGS_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <ListCustomerOnboardingScreen/>,
                },
            ]
        },
        {
            path: CREATE_CUSTOMER_ONBOARDING_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <CreateCustomerOnboardingScreen/>,
                },
            ]
        },
        {
            path: CUSTOMER_ONBOARDING_EDITION_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <CustomerOnboardingEditionScreen/>,
                },
            ]
        },
        {
            path: CURRENT_ACCOUNTS_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <ListCurrentAccountsScreen/>,
                },
            ]
        },
        {
            path: VIEW_CURRENT_ACCOUNT_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <CurrentAccountScreen/>,
                },
            ]
        },
        {
            path: AUTHORIZATIONS_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <ListAuthorizationsScreen/>,
                },
            ]
        },
        {
            path: AUTHORIZATION_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    path: VIEW_AUTHORIZATION_PATH,
                    element: <AuthorizationScreen/>,
                },
            ]
        },
        {
            path: USERS_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <ListMarketplaceUsersScreen/>,
                },
            ]
        }, {
            path: CREATE_USER_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <CreateUserScreen featureClass={CreateUserFeature}/>,
                },
            ]
        },{
            path: CREATE_BACKOFFICE_USER_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <CreateUserScreen featureClass={CreateBackofficeUserFeature}/>,
                },
            ]
        },
        {
            path: ASSIGN_ROLES_USER_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <AssignRolesScreen/>,
                },
            ]
        },
        {
            path: BACKOFFICE_USERS_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <ListBackofficeUsersScreen/>,
                },
            ]
        },
        {
            path: ASSIGN_PERMISSIONS_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <AssignPermissionsScreen/>,
                },
            ]
        },
        {
            path: CUSTOMERS_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <ListCustomersScreen/>,
                },
            ]
        },
        {
            path: CUSTOMER_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <CustomerScreen/>,
                },
            ]
        },
        {
            path: DELIVERY_SITE_ONBOARDING_CREATE_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <DeliverySiteOnboardingCreateScreen/>,
                },
            ]
        },
        {
            path: DELIVERY_SITE_ONBOARDING_EDIT_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <DeliverySiteOnboardingEditScreen/>,
                },
            ]
        },
        {
            path: DELIVERY_SITE_PATH,
            element: <AppLayoutScreen/>,
            children: [
                {
                    index: true,
                    element: <DeliverySiteScreen/>,
                },
            ]
        },
    ]
    const unauthenticatedRoutes = [
        {
            path: MARKETPLACE_DEMO_PATH,
            element: <MarketplaceDemoScreen/>,
        },
        {
            path: LOGIN_PATH,
            element: <LoginScreen/>,
        },
        {
            path: PASSWORD_RESET_PATH,
            element: <RecoverPasswordScreen/>,
        },
        {
            path: '*',
            element: <Navigate to={LOGIN_PATH}/>,
        },
    ]

    let routes;

    if (application.session().active()) {
        let userRoutes = [];
        authenticatedRoutes.forEach(item => {
            if (application.canAccessPath(item.path)){
                userRoutes.push(item)
            }
        });
        userRoutes.push({
            path: MARKETPLACE_DEMO_PATH,
            element: <MarketplaceDemoScreen/>,
        })
        userRoutes.push({
            path: LOGIN_PATH,
            element: <Navigate to={userRoutes[0].path}/>,
        })
        userRoutes.push({
            path: '*',
            element: <Navigate to={userRoutes[0].path}/>,
        })
        routes = createBrowserRouter([...userRoutes]);
    } else {
        routes = createBrowserRouter(unauthenticatedRoutes);
    }
    return <RouterProvider router={routes}/>;
}
